import Image from '@/components/Image';
import { FOOTER_URLS, FOOTER_LABELS } from '@/constants/index';
import tw, { styled } from 'twin.macro';
import * as footerTypes from '../../types/FooterTypes.type';
import Link from '../Link';

const Button = styled.button(() => [tw`py-2 justify-self-end cursor-pointer`]);
const StyledDiv = styled.div(() => [tw`py-2`]);

const StyledLI = styled.li(() => [tw`p-3 flex h-12`]);

type FooterTextParams =
  { gamblingHelpLineMALink: JSX.Element,
    fanduelRgLink: JSX.Element,
    ccpgLink: JSX.Element,
    kansasGamblingHelpLink: JSX.Element,
    mdgamblinghelpLink: JSX.Element,
    gamblerNetLink: JSX.Element };

export const footerText = ({
  gamblingHelpLineMALink, fanduelRgLink, ccpgLink,
  kansasGamblingHelpLink, mdgamblinghelpLink, gamblerNetLink,
} : FooterTextParams) => (
  <>
    {' '}
    Gambling Problem? Call 1-800-GAMBLER. Hope is here.
    {' '}
    {gamblingHelpLineMALink}
    {' '}
    or call (800)-327-5050 for 24/7 support (MA). Call 1-877-8HOPE-NY or Text HOPENY (467369) (NY).
    21+ in select states. FanDuel is offering online sports
    wagering in Kansas under an agreement with Kansas Star
    Casino, LLC. Gambling Problem? Call 1-800-GAMBLER or visit
    {' '}
    {fanduelRgLink}
    {' '}
    (CO, IA, MI, NJ, OH, PA, IL, TN, VA), 1-800-NEXT-STEP or text NEXTSTEP to 53342 (AZ),
    1-888-789-7777 or visit
    {' '}
    {ccpgLink}
    {' '}
    (CT), 1-800-9-WITH-IT (IN), 1-800-522-4700 or visit
    {' '}
    {kansasGamblingHelpLink}
    {' '}
    (KS), 1-877-770-STOP (LA), visit
    {' '}
    {mdgamblinghelpLink}
    {' '}
    (MD), 1-877-8-HOPENY or text HOPENY (467369) (NY), 1-800-522-4700 (WY), or visit
    {' '}
    {gamblerNetLink}
    (WV).
    {' '}
  </>
);

const linkCreator = ({ url, label }: { url: string, label: string }) => (
  <Link
    href={url}
    next={false}
  >
    { label}
  </Link>
);

export default function Copyright(footerProps: footerTypes.CopyrightProps) {
  const { copyrightItems } = footerProps;
  const scrollToTop = (): void => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };
  const copyrightImages = copyrightItems.map(
    (picture) => picture?.iconUrl && (
      <StyledLI key={picture.text + picture.iconUrl}>
        <Image
          alt={picture.text}
          src={picture?.iconUrl}
          width="0"
          height="0"
          sizes="100vw"
          style={{ width: '100%', height: '100%' }}
        />
      </StyledLI>
    ),
  );

  const fanduelRgLink = linkCreator({
    url: FOOTER_URLS.FANDUEL_RG_URL,
    label: FOOTER_LABELS.FANDUEL_RG_LABEL,
  });

  const ccpgLink = linkCreator({
    url: FOOTER_URLS.CCPG_URL,
    label: FOOTER_LABELS.CCPG_LABEL,
  });

  const gamblerNetLink = linkCreator({
    url: FOOTER_URLS.GAMBLER_NET_URL,
    label: FOOTER_LABELS.GAMBLER_NET_LABEL,
  });

  const gamblingHelpLineMALink = linkCreator({
    url: FOOTER_URLS.GAMBLING_HELPLINE_MA_URL,
    label: FOOTER_LABELS.GAMBLING_HELPLINE_MA_LABEL,
  });

  const kansasGamblingHelpLink = linkCreator({
    url: FOOTER_URLS.KANSAS_GAMBLING_HELP_URL,
    label: FOOTER_LABELS.KANSAS_GAMBLING_HELP_LABEL,
  });

  const mdgamblinghelpLink = linkCreator({
    url: FOOTER_URLS.MD_GAMBLING_HELP_URL,
    label: FOOTER_LABELS.MD_GAMBLING_HELP_LABEL,
  });

  return (
    <div tw="flex w-full flex-col px-4 text-xs">
      <div tw="mx-auto flex max-w-7xl  justify-items-center">
        <div tw="flex  w-full max-w-full flex-col justify-start text-base">
          <StyledDiv>
            © Betfair Interactive US LLC,
            {' '}
            {new Date().getFullYear()}
          </StyledDiv>
          <StyledDiv>
            {footerText({
              fanduelRgLink,
              ccpgLink,
              gamblerNetLink,
              gamblingHelpLineMALink,
              kansasGamblingHelpLink,
              mdgamblinghelpLink,
            })}
          </StyledDiv>
        </div>
      </div>
      <div tw="flex flex-col justify-between bg-gray-light p-5 text-xs md:flex-row">
        <ul tw=" flex flex-wrap justify-center text-[.75rem] sm:flex-nowrap">
          {copyrightImages}
        </ul>

        <Button
          tw="hidden whitespace-nowrap  sm:block"
          onClick={scrollToTop}
        >
          <p tw="text-light-blue">
            Back to Top ↑
          </p>
        </Button>
      </div>
    </div>
  );
}
